import type { FC, ReactNode } from "react";

import { AuthHeader, AuthHeaderWrapper, AuthFooter } from "@shared/components";
import { authRoutes } from "@unauthenticated/shared/data/authRoutes";
import { CountrySelect } from "@unauthenticated/signupSignin/components/CountrySelect";
import { Page } from "@unauthenticated/signupSignin/components/Page";
import { PageContent } from "@unauthenticated/signupSignin/components/PageContent";

interface Props {
  children: ReactNode;
}

const SignInLayout: FC<Props> = ({ children }) => {
  return (
    <Page>
      <PageContent>
        <AuthHeaderWrapper>
          <AuthHeader route={authRoutes.login} />
          <CountrySelect />
        </AuthHeaderWrapper>
        {children}
      </PageContent>
      <AuthFooter />
    </Page>
  );
};

export { SignInLayout };
